export enum AlarmZones {
	H4,
	H3,
	H2,
	H1,
	L1,
	L2,
	L3,
}
